<template>
  <div class="container-fluid">
    <div class="row body-row">
      <div class="col-md-3 col-lg-2 p-0 d-md-block bg-dark">
        <nav-main></nav-main>
      </div>
      <div class="col-md-9 ms-sm-auto col-lg-10 pt-3 ">
        <my-breadcrumb></my-breadcrumb>
        <nav-rest></nav-rest>
        <div>
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavMain from '../modules/NavMain'
import MyBreadcrumb from '../modules/Breadcrumb'
import NavRest from '../modules/NavRest'
import router from "@/router";
import {mapGetters} from "vuex";
export default {
  name: "Restaurant",
  components: {NavMain, MyBreadcrumb, NavRest},
  computed: {
    ...mapGetters([
      'COMPANY',
      'RESTAURANT',
    ]),
  },
  mounted() {
    // router.push({name: 'RestMenu'})
    let restId = this.$route.params.id; // получаем id текущего ресторана из роута
    if(!Object.values(this.COMPANY).length) {
      this.$store.dispatch('getCompanyInfo'); // получаем информацию о компании
    }
    if (!Object.values(this.RESTAURANT).length) { // проверяем пуст ли ресторан - такое бывает если обновить страницу
      const startRest = async () => {
        await this.$store.dispatch('getRestaurantItem', restId) //делаем асинхронную загрузку инфорамации о ресторане
      }
      startRest().then(() => { //когда получили информацию о ресторане
        this.$breadcrumbs.value[2].label = this.RESTAURANT.title //меняем заголовок страницы в breadcrumbs
        this.$store.dispatch('getRestaurantMenu', restId); // загружаем меню ресторна
      })
    } else {
      this.$breadcrumbs.value[2].label = this.RESTAURANT.title //меняем заголовок страницы в breadcrumbs
      this.$store.dispatch('getRestaurantMenu', restId); // загружаем меню ресторна
    }
  },
}
</script>

<style scoped>

</style>
